import { OrganizationDomain } from 'types';
import { CapitolaClient } from './base';

export class OrganizationDomainClient extends CapitolaClient<OrganizationDomain> {
  public get resourceName(): string {
    return 'organization-domain';
  }
}
